import { Box, Heading, Text, VStack, HStack, SimpleGrid, Button, Divider, useColorModeValue } from '@chakra-ui/react';
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { useNavigate } from "react-router-dom";
import PublicLayout from './PublicLayout';
import ImageBand from './Components/ImageBand';
import B2CMarkdownLongText from '../B2C-TestSeries/Components/B2CMarkDownLongText';


const markdownComponents = {
  h1: ({ children }: any) => <Heading as="h1" size="md" mt={4} mb={2}>{children}</Heading>,
  h2: ({ children }: any) => <Heading as="h2" size="sm" mt={4} mb={2}>{children}</Heading>,
  h3: ({ children }: any) => <Heading as="h3" size="xs" mt={3} mb={2}>{children}</Heading>,
  p: ({ children }: any) => <Text mb={3} lineHeight="1.8">{children}</Text>,
  ul: ({ children }: any) => <Box as="ul" pl={5} mb={3}>{children}</Box>,
  li: ({ children }: any) => <Box as="li" mb={1}>{children}</Box>,
  table: ({ children }: any) => (
    <Box overflowX="auto" mb={4}>
      <Box as="table" width="100%" style={{ borderCollapse: "collapse" }}>{children}</Box>
    </Box>
  ),
  th: ({ children }: any) => (
    <Box as="th" textAlign="left" p={2} borderBottom="2px solid" borderColor="gray.300" fontSize="sm">{children}</Box>
  ),
  td: ({ children }: any) => (
    <Box as="td" p={2} borderBottom="1px solid" borderColor="gray.200" fontSize="sm">{children}</Box>
  ),
};

interface CoachingDomainPageProps {
  bandImage: string;
  title: string;
  subtitle: string;
  accent: string;
  longDescription: string;
}

const CoachingDomainPage: React.FC<CoachingDomainPageProps> = ({
  bandImage,
  title,
  subtitle,
  accent,
  longDescription,
}) => {
  const navigate = useNavigate();
  const cardBg = useColorModeValue("white", "gray.800");
  const mutedText = useColorModeValue("gray.600", "gray.400");
  const isLight = useColorModeValue(true, false);

  return (
    <PublicLayout>

      {/* ================= COACHING HERO ================= */}

      <Box
        as="section"
        minH={{ base: "260px", md: "320px" }}
        bgImage={bandImage}
        bgSize="cover"
        bgPosition="right center"
        bgRepeat="no-repeat"
        position="relative"
        overflow="hidden"
      >

        {/* LEFT Gradient Overlay for readability */}

        <Box
          position="absolute"
          top="0"
          left="0"
          width="100%"
          height="100%"
          bgGradient="
            linear(
              to-r,
              rgba(0,0,0,0.68),
              rgba(0,0,0,0.35),
              rgba(0,0,0,0)
            )
          "
          zIndex={1}
        />

        {/* Content */}

        <Box
          position="relative"
          zIndex={2}
          minH={{ base: "260px", md: "320px" }}
          display="flex"
          alignItems="center"
          px={{ base: 6, md: 16 }}
        >

          <VStack
            align="flex-start"
            spacing={4}
            maxW="700px"
          >

            {/* Title */}

            <Heading
              color="white"
              size="2xl"
              lineHeight="1.2"
            >
              {title}
            </Heading>

            {/* Subtitle */}

            <Text
              color="gray.100"
              fontSize={{ base: "lg", md: "xl" }}
              fontWeight={"bold"}
            //  lineHeight="1.7"
              maxW="650px"
            >
              {subtitle}
            </Text>

          </VStack>

        </Box>

      </Box>

      {/* ================= PAGE CONTENT ================= */}

      <Box p={4}>
        <Box maxW="1400px" mx="auto" my={6}>

{/*           <Text
            fontSize="sm"
            fontWeight="bold"
            color={`${accent}.500`}
            textTransform="uppercase"
            mb={1}
          >
            {subtitle}
          </Text> */}

          <Box
            bg={isLight ? `${accent}.50` : `${accent}.900`}
            rounded="2xl"
            overflow="hidden"
            shadow="lg"
          >

            <Box
              height="6px"
              bg={`${accent}.500`}
            />

            <Box p={{ base: 6, md: 8 }}>
{/*               <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                components={markdownComponents}
              >
                {longDescription}
              </ReactMarkdown> */}

            <B2CMarkdownLongText
            content={longDescription}
            textAlign="left"
            />
            </Box>

          </Box>

          {/* Powered by Platform -- recurring element */}

          <Box
            mt={8}
            bg={useColorModeValue("blue.50", "blue.900")}
            borderRadius="lg"
            p={6}
          >
            <Heading size="sm" mb={2}>
              Powered by the Eduvic Learning Platform
            </Heading>

            <Text
              fontSize="sm"
              color={mutedText}
            >
              Your guided preparation is delivered through the same digital
              learning environment that supports Eduvic's online practice and
              assessment experience. Relevant Eduvic Practice Platform resources
              may also be included with your guided preparation.
            </Text>
          </Box>

          <Divider my={8} />

          <Box textAlign="center">

            <Heading size="md" mb={4}>
              Interested in Guided Preparation?
            </Heading>

            <HStack justify="center" spacing={4} wrap="wrap">

              <Button
                colorScheme={accent}
                onClick={() => navigate("/coaching/contact?topic=free-trial")}
              >
                Book Your Free Trial Class
              </Button>

              <Button
                variant="outline"
                colorScheme="blue"
                onClick={() => navigate("/practice")}
              >
                Explore Eduvic Practice
              </Button>

            </HStack>

          </Box>
        </Box>
      </Box>

    </PublicLayout>
  );
};

export default CoachingDomainPage;